"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _RadioButton = _interopRequireWildcard(require("./RadioButton.proptypes"));

var _constant = require("../constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var RadioWrapper = _styledComponents.default.div.withConfig({
  displayName: "RadioButton__RadioWrapper",
  componentId: "sc-u3qn7n-0"
})(function (_ref) {
  var alignItems = _ref.alignItems,
      isFullWidth = _ref.isFullWidth;
  return "\n  display: flex;\n  align-items: ".concat(alignItems, ";\n  flex-direction: row;\n  cursor: pointer;\n  ").concat(isFullWidth ? 'width: inherit' : '', ";\n  ");
});

var focusStyled = (0, _styledComponents.css)(["&:focus{box-shadow:0px 2px 4px rgba(0,0,0,0.08);}"]);

var Radio = _styledComponents.default.span.withConfig({
  displayName: "RadioButton__Radio",
  componentId: "sc-u3qn7n-1"
})(function (_ref2) {
  var theme = _ref2.theme,
      checked = _ref2.checked,
      color = _ref2.color,
      isReversed = _ref2.isReversed,
      borderColor = _ref2.borderColor,
      disabled = _ref2.disabled;
  return "\n  min-width: 20px;\n  max-width: 20px;\n  min-height: 20px;\n  max-height: 20px;\n  border-radius: 40px;\n  border: 1px solid ".concat(borderColor ? theme.colors[borderColor] : theme.colors.greyLight, ";\n  background: ").concat( // eslint-disable-next-line no-nested-ternary
  disabled ? theme.colors.greyLighter : checked ? theme.colors[color] : theme.colors.default, ";\n  ").concat(focusStyled, ";\n  &:focus {\n    border: 1px solid ").concat(theme.colors.secondary, ";\n  }\n  ").concat(isReversed ? "\n          order: 2;\n        " : '', "\n");
});

var CheckedMark = _styledComponents.default.span.withConfig({
  displayName: "RadioButton__CheckedMark",
  componentId: "sc-u3qn7n-2"
})(["width:8px;height:8px;background:", ";margin:6px;border-radius:40px;display:block;", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.default;
}, focusStyled);

var TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "RadioButton__TextWrapper",
  componentId: "sc-u3qn7n-3"
})(function (_ref4) {
  var vertical = _ref4.vertical,
      isReversed = _ref4.isReversed,
      isFullWidth = _ref4.isFullWidth,
      alignItems = _ref4.alignItems;
  return "\n    margin-left: ".concat(vertical ? '18px' : '8px', ";\n    display: inline-flex;\n    align-items: ").concat(alignItems, ";\n    width: calc(100% - 20px);\n  ").concat(isReversed ? "\n          order: 1;\n          margin-left: ".concat(vertical ? '0px' : '8px', ";\n          margin-right: ").concat(vertical ? '0px' : '8px', ";\n        ") : '', "\n\n  ").concat(isFullWidth && 'width: 100%;', "\n");
});

var ImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "RadioButton__ImageWrapper",
  componentId: "sc-u3qn7n-4"
})(["margin-left:", ";margin-right:", ";vertical-align:middle;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.micro;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.tiny;
});

var TextInnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "RadioButton__TextInnerWrapper",
  componentId: "sc-u3qn7n-5"
})(["& > p{display:flex;}"]);

var RadioButton = function RadioButton(_ref7) {
  var theme = _ref7.theme,
      selected = _ref7.selected,
      text = _ref7.text,
      onChange = _ref7.onChange,
      vertical = _ref7.vertical,
      accessible = _ref7.accessible,
      customProperties = _ref7.customProperties,
      color = _ref7.color,
      icon = _ref7.icon,
      isReversed = _ref7.isReversed,
      isFullWidth = _ref7.isFullWidth,
      viewport = _ref7.viewport,
      textColor = _ref7.textColor,
      boldText = _ref7.boldText,
      borderColor = _ref7.borderColor,
      hideButton = _ref7.hideButton,
      subText = _ref7.subText,
      subTextColor = _ref7.subTextColor,
      disabled = _ref7.disabled;
  var tabIndex = !accessible ? '-1' : '0';

  var handelKeyDown = function handelKeyDown(event) {
    if (disabled) return;

    if (event.key === 'Enter') {
      event.preventDefault();
      onChange();
    }
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var iconTextType = function iconTextType() {
    if (icon) return viewport === _constant.DEVICE_TYPE.DESKTOP ? 'medium' : 'default';
    return null;
  };

  var getAlignItems = function getAlignItems() {
    return subText ? 'start' : 'center';
  };

  var onChangeHandler = function onChangeHandler() {
    if (disabled) return;
    onChange();
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(RadioWrapper, (0, _extends2.default)({
      onMouseDown: onChangeHandler,
      theme: themeContext,
      onKeyDown: handelKeyDown,
      isFullWidth: isFullWidth,
      tabIndex: tabIndex,
      alignItems: getAlignItems()
    }, customProperties), !hideButton && /*#__PURE__*/_react.default.createElement(Radio, {
      checked: selected,
      color: color,
      isReversed: isReversed,
      borderColor: borderColor,
      disabled: disabled
    }, selected && /*#__PURE__*/_react.default.createElement(CheckedMark, null)), /*#__PURE__*/_react.default.createElement(TextWrapper, {
      vertical: vertical,
      isReversed: isReversed,
      isFullWidth: isFullWidth,
      alignItems: getAlignItems()
    }, /*#__PURE__*/_react.default.createElement(InlineIcon, {
      icon: icon
    }), /*#__PURE__*/_react.default.createElement(TextInnerWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: false,
      type: iconTextType() || 'sub',
      color: textColor,
      bold: !!icon || boldText
    }, text), subText && /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: false,
      type: iconTextType() || 'sub',
      color: subTextColor,
      bold: !!icon || boldText
    }, subText))));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

var InlineIcon = function InlineIcon(props) {
  var icon = props.icon;
  return icon && icon.props.src ? /*#__PURE__*/_react.default.createElement(ImageWrapper, null, icon) : null;
};

RadioButton.propTypes = _RadioButton.default.PropTypes;
RadioButton.defaultProps = _RadioButton.default.DefaultProps;
InlineIcon.propTypes = _RadioButton.InlineIconProptypes.PropTypes;
var _default = RadioButton;
exports.default = _default;